/**
 * @generated SignedSource<<3e9a4973852355a32631f24811656c16>>
 * @relayHash d2499dd0207c02235f356557d14b8866
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 21fff83247cabdec84bd55483fd872649cb4112ceec17c36740cd49b4b85e53e

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type SettingsNavigationCustomisationInput = {
  entityAri: string;
  ownerAri?: string | null | undefined;
  properties?: ReadonlyArray<SettingsDisplayPropertyInput | null | undefined> | null | undefined;
  sidebar?: ReadonlyArray<SettingsMenuItemInput | null | undefined> | null | undefined;
};
export type SettingsDisplayPropertyInput = {
  key: string;
  value: string;
};
export type SettingsMenuItemInput = {
  menuId: string;
  visible: boolean;
};
export type updateNavigationCustomisationMutation$variables = {
  input: SettingsNavigationCustomisationInput;
};
export type updateNavigationCustomisationMutation$data = {
  readonly settings_updateNavigationCustomisation: {
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly key: string | null | undefined;
        readonly value: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type updateNavigationCustomisationMutation = {
  response: updateNavigationCustomisationMutation$data;
  variables: updateNavigationCustomisationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "concreteType": "SettingsDisplayPropertyConnection",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "SettingsDisplayProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "updateNavigationCustomisationMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_updateNavigationCustomisation",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateNavigationCustomisationMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_updateNavigationCustomisation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "21fff83247cabdec84bd55483fd872649cb4112ceec17c36740cd49b4b85e53e",
    "metadata": {},
    "name": "updateNavigationCustomisationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "bd07a6abe3570c8016127c30aea341e9";

export default node;
